import axios from "axios";

const MY_SERVER = '/api/'

const getCSRFToken = () => {
    return document.cookie
      .split('; ')
      .find((row) => row.startsWith('csrftoken='))
      ?.split('=')[1];
  };

  export function submitCardInteraction({ gameType, type_of_card, player, skipped, stopped_by, shot_player }, getState) {
    const sessionId = getState().gameStatus.sessions[gameType]?.sessionId;
    if (!sessionId) throw new Error(`No sessionId found for game type "${gameType}"`);

    return axios.post(MY_SERVER + 'add_card_interaction/', {
        session_id: sessionId,
        type_of_card,
        player,
        skipped,
        ...(stopped_by != null && { stopped_by }),
        ...(shot_player && { shot_player }),
      }, {
        withCredentials: true,
        headers: {
          'X-CSRFToken': getCSRFToken(),
        },
      })
      .then((res) => res.data);
  }
  